import styled from 'styled-components';

export const HeaderContainer = styled.div`
  position: sticky;
  z-index: 2;
  top: 0;
  background-color: ${(props) => props.theme.colors.gray2};
  width: 100%;
`;

export const HeaderContent = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
  & .coinTotal {
    .coins {
      margin: auto;
    }
  }

  // Removido via CSS
  // O componente do Header é HEFESTO e não tem a props para inibir a renderização do icone.
  .bell:nth-child(1) {
    display: none;
  }
`;
